export default __webpack_public_path__ + "static/media/eye.e98f3974.svg";